<template>
  <div class="learning-report-page">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-background">
        <div class="header-content">
          <div class="title-section">
            <div class="title-icon">
        <i class="el-icon-data-analysis"></i>
    </div>
            <div class="title-text">
              <h1 class="page-title">学习报告</h1>
              <p class="page-subtitle">
                学习报告展现了您最近一周内每天学习的单词次数量、本月学习时间；以及测试成绩等数据。
              </p>
            </div>
            </div>
          <div class="header-stats">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="el-icon-trophy"></i>
          </div>
              <div class="stat-content">
                <div class="stat-number">{{ getTotalWords() }}</div>
                <div class="stat-label">总学习单词</div>
            </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">
                <i class="el-icon-time"></i>
          </div>
              <div class="stat-content">
                <div class="stat-number">{{ monthlyStudyTime.total }}</div>
                <div class="stat-label">本月学习时间(分钟)</div>
            </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">
                <i class="el-icon-medal"></i>
          </div>
              <div class="stat-content">
                <div class="stat-number">{{ getPassedTests() }}</div>
                <div class="stat-label">通过测试</div>
            </div>
            </div>
            </div>
          </div>
        </div>
      </div>

    <div class="report-content">
      <!-- 最近一周学习情况图表 -->
      <div class="chart-section">
        <div class="chart-card">
          <div class="card-header">
            <div class="card-title">
              <i class="el-icon-trend-charts"></i>
              <span>最近一周学习情况</span>
            </div>
            <div class="card-subtitle">每日单词学习数量趋势</div>
        </div>
          <div class="chart-container">
            <!-- 如果没有数据，显示占位内容 -->
            <div v-if="weeklyData.length === 0" class="no-data-placeholder">
              <div class="placeholder-icon">
                <i class="el-icon-data-line"></i>
      </div>
              <div class="placeholder-text">
                <h3>暂无学习数据</h3>
                <p>开始学习单词后，这里将显示您最近一周的学习趋势</p>
        </div>
      </div>

            <!-- 有数据时显示图表 -->
            <div v-else class="chart-wrapper">
              <div class="chart-bars">
                <div 
                  v-for="(item, index) in weeklyData" 
                  :key="index" 
                  class="bar-item"
                  @mouseenter="showTooltip($event, item)"
                  @mouseleave="hideTooltip"
                >
                  <div class="bar-container">
                    <div 
                      class="bar" 
                      :style="{ 
                        height: getBarHeight(item.wordsCount) + 'px',
                        background: getBarColor(item.wordsCount)
                      }"
                    ></div>
                    <div class="bar-glow" :style="{ height: getBarHeight(item.wordsCount) + 'px' }"></div>
              </div>
                  <div class="bar-label">{{ item.date }}</div>
                  <div class="bar-value">{{ item.wordsCount }}</div>
            </div>
          </div>
              <div class="chart-line">
                <svg class="line-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
                  <polyline 
                    :points="getLinePoints()" 
                    fill="none" 
                    stroke="#409EFF" 
                    stroke-width="2"
                    stroke-dasharray="5,5"
                    class="trend-line"
                  />
                </svg>
                <div 
                  v-for="(item, index) in weeklyData" 
                  :key="index" 
                  class="line-point"
                  :style="{ 
                    left: (index * 14.28) + '%',
                    bottom: getLineHeight(item.trendValue) + 'px'
                  }"
                >
                  <div class="point-circle"></div>
                  <div class="point-value">{{ item.trendValue }}</div>
        </div>
              </div>
            </div>
            </div>
          </div>
        </div>

      <!-- 本月学习时间统计 -->
      <div class="chart-section">
        <div class="chart-card">
          <div class="card-header">
            <div class="card-title">
              <i class="el-icon-pie-chart"></i>
              <span>本月学习时间统计</span>
              </div>
            <div class="card-subtitle">总计: {{ monthlyStudyTime.total }}分钟</div>
            </div>
          <div class="chart-container">
            <div class="pie-chart-wrapper">
              <div class="pie-chart">
                <!-- 简洁环形饼图 -->
                <div class="simple-donut">
                  <div class="donut-chart">
                    <div class="donut-segment blue" :style="{ '--percentage': '32%' }"></div>
                    <div class="donut-segment orange" :style="{ '--percentage': '68%' }"></div>
                    <div class="donut-center">
                      <div class="center-value">{{ monthlyStudyTime.total }}</div>
                      <div class="center-label">分钟</div>
            </div>
            </div>
                  <div class="donut-legend">
                    <div class="legend-item">
                      <div class="legend-dot blue"></div>
                      <span class="legend-text">单词识别 {{ Math.round(monthlyStudyTime.total * 0.32) }}分钟 (32%)</span>
          </div>
                    <div class="legend-item">
                      <div class="legend-dot orange"></div>
                      <span class="legend-text">单词拼写 {{ Math.round(monthlyStudyTime.total * 0.68) }}分钟 (68%)</span>
        </div>
      </div>
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 测试记录表格 -->
      <div class="table-section">
        <div class="chart-card">
          <div class="card-header">
            <div class="card-title">
              <i class="el-icon-document"></i>
              <span>测试记录</span>
            </div>
            <div class="card-subtitle">最近的测试成绩记录</div>
            </div>
          <div class="table-container">
            <!-- 如果没有测试记录，显示占位内容 -->
            <div v-if="testRecords.length === 0" class="no-data-placeholder">
              <div class="placeholder-icon">
                <i class="el-icon-document"></i>
          </div>
              <div class="placeholder-text">
                <h3>暂无测试记录</h3>
                <p>完成单元测试后，这里将显示您的测试成绩记录</p>
        </div>
      </div>
            
            <!-- 有数据时显示表格 -->
            <el-table v-else :data="testRecords" style="width: 100%" stripe class="custom-table">
              <el-table-column prop="id" label="序号" width="80" align="center">
                <template slot-scope="scope">
                  <div class="table-number">{{ scope.row.id }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="stage_name" label="课本" min-width="200">
                <template slot-scope="scope">
                  <div class="table-text">{{ scope.row.stage_name }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="test_type" label="测试类型" width="120" align="center">
                <template slot-scope="scope">
                  <el-tag size="mini" type="info">{{ scope.row.test_type }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="unit" label="单元" width="80" align="center">
                <template slot-scope="scope">
                  <div class="table-unit">第{{ scope.row.unit }}单元</div>
                </template>
              </el-table-column>
              <el-table-column prop="score" label="分数" width="100" align="center">
                <template slot-scope="scope">
                  <div class="score-badge" :class="getScoreClass(scope.row.score)">
                    {{ scope.row.score }}
    </div>
                </template>
              </el-table-column>
              <el-table-column prop="is_passed" label="通过" width="100" align="center">
                <template slot-scope="scope">
                  <div class="pass-badge" :class="scope.row.is_passed === '是' ? 'passed' : 'failed'">
                    <i :class="scope.row.is_passed === '是' ? 'el-icon-check' : 'el-icon-close'"></i>
                    {{ scope.row.is_passed }}
        </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="table-footer">
              <el-pagination
                @current-change="handlePageChange"
                :current-page="testRecordsPagination.currentPage"
                :page-size="testRecordsPagination.pageSize"
                :total="testRecordsPagination.total"
                :page-sizes="[5, 10, 20]"
                @size-change="handleSizeChange"
                layout="total, sizes, prev, pager, next, jumper"
                class="test-records-pagination">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 工具提示 -->
    <div v-if="tooltip.show" class="tooltip" :style="tooltip.style">
      <div class="tooltip-content">
        <div class="tooltip-title">{{ tooltip.data.date }}</div>
        <div class="tooltip-value">学习单词: {{ tooltip.data.wordsCount }}个</div>
        <div class="tooltip-trend">总学习: {{ tooltip.data.trendValue }}个</div>
      </div>
    </div>
  </div>
</template>

<script>
import LearningReportAPI from "@/api/learningReport";

export default {
  name: "LearningReport",
  data() {
    return {
      loading: false,
      weeklyData: [],
      monthlyStudyTime: {
        total: 0,
        categories: []
      },
      testRecords: [],
      testRecordsPagination: {
        currentPage: 1,
        pageSize: 5,
        total: 0,
        totalPages: 0
      },
      tooltip: {
        show: false,
        style: {},
        data: {}
      }
    };
  },
  async mounted() {
    await this.loadReportData();
  },
  methods: {
    // 加载报告数据
    async loadReportData() {
      this.loading = true;
      try {
        console.log('开始加载学习报告数据...');
        const response = await LearningReportAPI.getLearningReport({
          page: this.testRecordsPagination.currentPage,
          pageSize: this.testRecordsPagination.pageSize
        });
        console.log('学习报告API响应:', response);
        
        if (response && response.success) {
          this.weeklyData = response.data.weeklyData || [];
          this.monthlyStudyTime = response.data.monthlyStudyTime || { total: 0, categories: [] };
          
          // 处理分页的测试记录数据
          const testRecordsData = response.data.testRecords || {};
          this.testRecords = testRecordsData.records || [];
          this.testRecordsPagination = {
            currentPage: Number(testRecordsData.page) || 1,
            pageSize: Number(testRecordsData.pageSize) || 5,
            total: Number(testRecordsData.total) || 0,
            totalPages: Number(testRecordsData.totalPages) || 0
          };
          
          // 添加调试信息
          console.log('学习报告数据加载成功:', {
            weeklyData: this.weeklyData,
            weeklyDataLength: this.weeklyData.length,
            monthlyStudyTime: this.monthlyStudyTime,
            testRecords: this.testRecords,
            testRecordsLength: this.testRecords.length
          });
          
          // 如果没有数据，显示提示
          if (this.weeklyData.length === 0) {
            console.warn('周学习数据为空');
          }
          if (this.testRecords.length === 0) {
            console.warn('测试记录为空');
          }
        } else {
          console.error('学习报告API返回失败:', response);
          this.$message.error(response?.message || '获取学习报告失败');
        }
      } catch (error) {
        console.error('加载学习报告失败:', error);
        this.$message.error('加载学习报告失败: ' + error.message);
      } finally {
        this.loading = false;
      }
    },

    // 获取柱状图高度
    getBarHeight(value) {
      const maxValue = Math.max(...this.weeklyData.map(item => item.wordsCount));
      return maxValue > 0 ? (value / maxValue) * 150 : 0;
    },

    // 获取折线图高度
    getLineHeight(value) {
      const maxValue = Math.max(...this.weeklyData.map(item => item.trendValue));
      return maxValue > 0 ? (value / maxValue) * 150 : 0;
    },

    // 获取分数样式类
    getScoreClass(score) {
      if (score >= 90) return 'excellent';
      if (score >= 80) return 'good';
      if (score >= 60) return 'pass';
      return 'fail';
    },
    
    // 处理页码变化
    async handlePageChange(page) {
      this.testRecordsPagination.currentPage = page;
      await this.loadReportData();
    },
    
    // 处理每页大小变化
    async handleSizeChange(size) {
      this.testRecordsPagination.pageSize = size;
      this.testRecordsPagination.currentPage = 1; // 重置到第一页
      await this.loadReportData();
    },

    // 获取总学习单词数
    getTotalWords() {
      return this.weeklyData.reduce((total, item) => total + item.wordsCount, 0);
    },

    // 获取通过测试数
    getPassedTests() {
      return this.testRecords.filter(record => record.is_passed === '是').length;
    },

    // 获取柱状图颜色
    getBarColor(value) {
      const maxValue = Math.max(...this.weeklyData.map(item => item.wordsCount));
      if (maxValue === 0) return '#E4E7ED';
      
      const ratio = value / maxValue;
      if (ratio >= 0.8) return 'linear-gradient(135deg, #67C23A, #85CE61)';
      if (ratio >= 0.6) return 'linear-gradient(135deg, #409EFF, #66B1FF)';
      if (ratio >= 0.4) return 'linear-gradient(135deg, #E6A23C, #EEBE77)';
      return 'linear-gradient(135deg, #F56C6C, #F78989)';
    },

    // 获取折线图点坐标
    getLinePoints() {
      if (this.weeklyData.length === 0) return '';
      
      const maxValue = Math.max(...this.weeklyData.map(item => item.trendValue));
      if (maxValue === 0) return '';
      
      const points = this.weeklyData.map((item, index) => {
        const x = (index / (this.weeklyData.length - 1)) * 100;
        const y = 100 - (item.trendValue / maxValue) * 100;
        return `${x},${y}`;
      });
      
      return points.join(' ');
    },


    // 获取饼图起始角度（已废弃，使用SVG方法）
    getPieStartAngle(index) {
      let startAngle = 0;
      for (let i = 0; i < index; i++) {
        startAngle += this.monthlyStudyTime.categories[i].percentage * 3.6;
      }
      return startAngle;
    },

    // 获取饼图旋转角度（已废弃，使用getPieStartAngle）
    getPieRotation(index) {
      let rotation = 0;
      for (let i = 0; i < index; i++) {
        rotation += this.monthlyStudyTime.categories[i].percentage * 3.6;
      }
      return rotation;
    },

    // 显示工具提示
    showTooltip(event, data) {
      const rect = event.target.getBoundingClientRect();
      this.tooltip = {
        show: true,
        style: {
          left: rect.left + rect.width / 2 + 'px',
          top: rect.top - 10 + 'px',
          transform: 'translateX(-50%)'
        },
        data: data
      };
    },

    // 隐藏工具提示
    hideTooltip() {
      this.tooltip.show = false;
    }
  }
};
</script>

<style scoped>
.learning-report-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 0;
}

/* 页面头部 */
.page-header {
  position: relative;
  overflow: hidden;
}

.header-background {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 40px 20px;
  position: relative;
}

.header-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="50" cy="10" r="0.5" fill="rgba(255,255,255,0.05)"/><circle cx="10" cy="60" r="0.5" fill="rgba(255,255,255,0.05)"/><circle cx="90" cy="40" r="0.5" fill="rgba(255,255,255,0.05)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
}

.header-content {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-section {
  display: flex;
  align-items: center;
  color: white;
}

.title-icon {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.title-icon i {
  font-size: 36px;
  color: white;
}

.title-text h1 {
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 10px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.title-text p {
  font-size: 16px;
  margin: 0;
  opacity: 0.9;
  line-height: 1.5;
}

.header-stats {
  display: flex;
  gap: 20px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  min-width: 160px;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.25);
}

.stat-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.stat-icon i {
  font-size: 24px;
  color: white;
}

.stat-content {
  color: white;
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 12px;
  opacity: 0.8;
}

/* 内容区域 */
.report-content {
  padding: 30px 20px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.chart-section {
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.chart-section:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.chart-card {
  padding: 30px;
}

.card-header {
  margin-bottom: 30px;
  text-align: center;
}

.card-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.card-title i {
  font-size: 28px;
  margin-right: 10px;
  color: #409EFF;
}

.card-subtitle {
  color: #666;
  font-size: 14px;
}

/* 图表容器 */
.chart-container {
  height: 400px;
  position: relative;
}

.chart-wrapper {
  height: 100%;
  position: relative;
}

/* 柱状图样式 */
.chart-bars {
  display: flex;
  align-items: flex-end;
  height: 250px;
  padding: 0 20px;
  border-bottom: 2px solid #f0f0f0;
  position: relative;
}

.bar-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.bar-item:hover {
  transform: scale(1.05);
}

.bar-container {
  position: relative;
  margin-bottom: 15px;
}

.bar {
  width: 40px;
  border-radius: 8px 8px 0 0;
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.bar-glow {
  width: 40px;
  border-radius: 8px 8px 0 0;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(64, 158, 255, 0.3);
  filter: blur(8px);
  z-index: 1;
  transition: all 0.3s ease;
}

.bar-item:hover .bar-glow {
  filter: blur(12px);
  background: rgba(64, 158, 255, 0.5);
}

.bar-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.bar-value {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

/* 折线图样式 */
.chart-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 250px;
  pointer-events: none;
}

.line-svg {
  width: 100%;
  height: 100%;
}

.trend-line {
  animation: dash 2s linear infinite;
}

@keyframes dash {
  to {
    stroke-dashoffset: -10;
  }
}

.line-point {
  position: absolute;
  transform: translateX(-50%);
}

.point-circle {
  width: 12px;
  height: 12px;
  background: #409EFF;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.4);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.4);
  }
  50% {
    transform: scale(1.2);
    box-shadow: 0 4px 16px rgba(64, 158, 255, 0.6);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.4);
  }
}

.point-value {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #409EFF;
  font-weight: 600;
  background: rgba(64, 158, 255, 0.1);
  padding: 4px 8px;
  border-radius: 12px;
  white-space: nowrap;
}

/* 饼图样式 */
.pie-chart-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 40px;
}

.pie-chart {
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 50%;
}

.pie-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg); /* 从顶部开始 */
}

.pie-segment {
  transition: all 0.3s ease;
}

.pie-segment:hover {
  stroke-width: 45;
  filter: brightness(1.1);
}

.pie-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 10;
}

.pie-total {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  line-height: 1;
}

.pie-unit {
  font-size: 14px;
  color: #666;
  margin-top: 5px;
}

.pie-slice {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.pie-slice:hover {
  transform: scale(1.05);
}

.pie-legend {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.legend-item {
  display: flex;
  align-items: center;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.legend-item:hover {
  background: #e9ecef;
  transform: translateX(5px);
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  margin-right: 12px;
}

.legend-content {
  flex: 1;
}

.legend-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
}

.legend-value {
  font-size: 12px;
  color: #666;
}

/* 表格样式 */
.table-container {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
}

.custom-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.table-number {
  background: #409EFF;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  margin: 0 auto;
}

.table-text {
  font-weight: 500;
  color: #333;
}

.table-unit {
  background: #e9ecef;
  color: #666;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.score-badge {
  padding: 6px 12px;
  border-radius: 16px;
  font-weight: 600;
  font-size: 14px;
  display: inline-block;
}

.score-badge.excellent {
  background: linear-gradient(135deg, #67C23A, #85CE61);
  color: white;
}

.score-badge.good {
  background: linear-gradient(135deg, #409EFF, #66B1FF);
  color: white;
}

.score-badge.pass {
  background: linear-gradient(135deg, #E6A23C, #EEBE77);
  color: white;
}

.score-badge.fail {
  background: linear-gradient(135deg, #F56C6C, #F78989);
  color: white;
}

.pass-badge {
  padding: 6px 12px;
  border-radius: 16px;
  font-weight: 600;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.pass-badge.passed {
  background: linear-gradient(135deg, #67C23A, #85CE61);
  color: white;
}

.pass-badge.failed {
  background: linear-gradient(135deg, #F56C6C, #F78989);
  color: white;
}

.table-footer {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}

.more-btn {
  color: #409EFF;
  font-weight: 500;
  transition: all 0.3s ease;
}

.more-btn:hover {
  color: #66B1FF;
  transform: translateY(-2px);
}

/* 分页组件样式 */
.test-records-pagination {
  margin-top: 20px;
  text-align: center;
}

.test-records-pagination .el-pagination__total {
  color: #606266;
  font-size: 14px;
}

.test-records-pagination .el-pagination__sizes .el-select .el-input__inner {
  font-size: 14px;
}

.test-records-pagination .el-pager li {
  font-size: 14px;
}

.test-records-pagination .btn-prev,
.test-records-pagination .btn-next {
  font-size: 14px;
}

/* 简洁环形饼图设计 */
.pie-chart {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  padding: 20px;
  min-height: 350px;
}

.simple-donut {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.donut-chart {
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: conic-gradient(
    #409EFF 0deg 115.2deg,
    #E6A23C 115.2deg 360deg
  );
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}

.donut-chart::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  background: white;
  border-radius: 50%;
  box-shadow: inset 0 0 10px rgba(0,0,0,0.05);
}

.donut-segment {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.donut-segment:hover {
  transform: scale(1.02);
}

.donut-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 10;
}

.center-value {
  font-size: 28px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 4px;
}

.center-label {
  font-size: 12px;
  color: #909399;
  font-weight: 500;
}

.donut-legend {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 300px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.legend-item:hover {
  background: #e9ecef;
  transform: translateX(4px);
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.legend-dot.blue {
  background: #409EFF;
}

.legend-dot.orange {
  background: #E6A23C;
}

.legend-text {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.pie-chart-wrapper {
  display: flex;
  align-items: center;
  gap: 30px;
}

/* 图例美化 */
.pie-legend {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  border: 1px solid rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.legend-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.legend-content {
  flex: 1;
}

.legend-name {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.legend-value {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}

.placeholder-icon {
  font-size: 48px;
  color: #adb5bd;
  margin-bottom: 20px;
  opacity: 0.7;
}

.placeholder-text h3 {
  color: #6c757d;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.placeholder-text p {
  color: #868e96;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

/* 工具提示 */
.tooltip {
  position: fixed;
  z-index: 1000;
  pointer-events: none;
}

.tooltip-content {
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.tooltip-title {
  font-weight: 600;
  margin-bottom: 4px;
}

.tooltip-value,
.tooltip-trend {
  margin-bottom: 2px;
  opacity: 0.9;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 30px;
  }

  .header-stats {
    flex-wrap: wrap;
    justify-content: center;
  }

  .stat-card {
    min-width: 140px;
  }

  .title-icon {
    width: 60px;
    height: 60px;
  }
  
  .title-icon i {
    font-size: 28px;
}

  .title-text h1 {
    font-size: 28px;
  }
  
  .chart-container {
    height: 300px;
  }
  
  .chart-bars {
    height: 200px;
    padding: 0 10px;
  }
  
  .bar {
    width: 30px;
  }
  
  .pie-chart-wrapper {
    flex-direction: column;
    gap: 20px;
  }
  
  .pie-chart {
    width: 150px;
    height: 150px;
  }
  
  .pie-total {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .report-content {
    padding: 20px 10px;
  }
  
  .chart-card {
    padding: 20px;
  }
  
  .header-background {
    padding: 30px 15px;
  }
  
  .stat-card {
    min-width: 120px;
    padding: 15px;
  }
  
  .stat-number {
    font-size: 20px;
  }
}
</style>